import { useEffect, useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { Link, useHistory } from "react-router-dom";
import { projectPrimaryColor } from "../../generalConfigs";
//Icons
import { parseInvestorTypeSimple } from "../../utils";
import { MdDone, MdEdit, MdExpandMore } from "react-icons/md";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { IoIosArrowUp } from "react-icons/io";
import { GiCoffeeCup, GiRocket, GiRunningNinja, GiWalk } from "react-icons/gi";
import useProfilePicture from "../../hooks/useProfilePicture";
import { useUser } from "../../hooks/useUser";
import Swal from "sweetalert2";

export default function UserAccountSettings() {
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);
  const [newProfileImage, setNewProfileImage] = useState("");
  const [investorProfiles, setInvestorProfiles] = useState(
    defaultInvestorProfiles
  );
  const [expandedButtons, setExpandedButtons] = useState({
    profilePictures: false,
    investorTypes: false,
  });
  const [userName, setUserName] = useState("");
  const [newPasswordValue, setNewPasswordValue] = useState("");
  const [confirmNewPasswordValue, setConfirmNewPasswordValue] = useState("");
  const [oldPasswordValue, setOldPasswordValue] = useState("");
  const [file, setFile] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [isExternalAuth, setIsExternalAuth] = useState(false);
  const [allDone, setAllDone] = useState(false);

  const history = useHistory();
  const { getProfilePictureURI } = useProfilePicture();
  const {
    getUserDetails,
    reloadUserCachedDetails,
    updateUserDetails,
    uploadProfileImage,
  } = useUser();

  //Handle click to expand investor type and show others investor types.
  const handleInvestorTypesExpands = () => {
    let newExpandedState = {
      profilePictures: expandedButtons.profilePictures,
      investorTypes: !expandedButtons.investorTypes,
    };
    setExpandedButtons(newExpandedState);
  };

  //Handle click in new investor profile and change the state.
  const handleInvestorTypeClick = (id) => {
    let newInvestorProfileState = investorProfiles.map((item, i) => {
      if (i === id) {
        item.status = true;
        return item;
      } else {
        item.status = false;
        return item;
      }
    });
    setInvestorProfiles(newInvestorProfileState);
  };

  /**
   * Determines which investor profile need to be shown
   * if the user selected a new investor profile -
   * then, it will return a selection.
   * otherwise, will return a userData selection.
   * @returns {Number}
   */
  const getInvestorTypeToShow = () => {
    if (!userData) {
      return null;
    }
    let userSelectedInvestor = null;
    investorProfiles.forEach((item) => {
      if (
        item.status === true &&
        item.investorType !== userData.investor_type
      ) {
        userSelectedInvestor = item.investorType;
      }
    });
    if (userSelectedInvestor || userSelectedInvestor === 0) {
      return userSelectedInvestor;
    }
    return userData.investor_type;
  };

  //Send data
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMsg("");
    //Data that will be send to backend.
    let sendData = {
      userName: userName,
      profilePicture: newProfileImage,
      investorType: getInvestorTypeToShow(),
      newPassword: newPasswordValue.length > 0 ? newPasswordValue : null,

      confirmNewPassword:
        confirmNewPasswordValue.length > 0 ? confirmNewPasswordValue : null,

      oldPassword: oldPasswordValue.length > 0 ? oldPasswordValue : null,
    };

    //Do the request to update user details
    let updateDetails = await updateUserDetails(sendData);
    if (updateDetails) {
      if (updateDetails.status === 1) {
        //Everything went well, change the state of all done.
        await reloadUserCachedDetails();
        setAllDone(true);
        setIsLoading(false);
      } else {
        //Error ocourred, let's catch then,
        let msg = updateDetails.msg;
        let errorMsg = "";
        if (msg === "Incorrect Old Password") {
          errorMsg =
            "Sua senha antiga não está correta, por favor, verifique tente novamente";
        } else if (msg === "Passwords doesnt match") {
          errorMsg =
            "O campo de confirmação de senha não coincide, por favor, verifique os campos e tente novamente.";
        } else if (msg === "Error on fields") {
          errorMsg =
            "Ocorreu um erro nos seus dados, por favor, tente novamente mais tarde.";
        } else {
          errorMsg =
            "Ocorreu um erro desconhecido, por favor, tente novamente mais tarde.";
        }
        setErrorMsg(errorMsg);
        setIsLoading(false);
      }
    }
  };

  function handleFileChange(event) {
    if (isLoadingUpload) {
      return;
    }
    event.preventDefault();
    const file = event?.target?.files?.[0];

    if (event.target.files) {
      setFile(file);
    }
  }

  async function handleUploadImage() {
    if (!file) {
      return;
    }
    setIsLoadingUpload(true);

    const response = await uploadProfileImage(file);

    if (response) {
      const msg = response.msg;

      if (msg === "Uploaded successfully" && response.fileName) {
        setNewProfileImage(response.fileName);
      } else if (msg === "image not acceptable") {
        Swal.fire({
          icon: "error",
          title: "Imagem incompatível.",
          confirmButtonColor: projectPrimaryColor,
          text: "Atualmente aceitamos apenas imagens nos seguintes formatos: jpeg, jpg, png. Com um tamanho máximo de até 7MB, certifique de selecionar uma imagem que atenda esses critérios.",
          background: "var(--bg-1)",
          color: "var(--text-1)",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Ocorreu um erro desconhecido, que tal tentar novamente?!",
        confirmButtonColor: projectPrimaryColor,
        background: "var(--bg-1)",
        color: "var(--text-1)",
      });
    }

    setIsLoadingUpload(false);
  }

  useEffect(() => {
    if (file) {
      handleUploadImage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  //Fetch user data.
  useEffect(() => {
    setIsLoading(true);

    let fetchData = async () => {
      let request = await getUserDetails();
      if (request) {
        if (request && request.status === 1) {
          setUserData(request.data);
          setUserName(request.data.name);
          setNewProfileImage(request.data.profile_picture);
          setIsExternalAuth(request.data.is_external_auth);
          setIsLoading(false);
        } else {
          setUserData("error");
          setIsLoading(false);
        }
      } else {
        setUserData("error");
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return loadingSkeleton();
  }

  if (allDone) {
    return allDonePage();
  }

  if (userData && userData !== "error") {
    return (
      <Modal show={true} fullscreen={true} size="md">
        <div className="row pd-r-15 pd-l-15 pd-t-15">
          <div className="col-6"></div>
          <div
            className="col-6"
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <span onClick={() => history.goBack()}>
              <AiOutlineCloseCircle
                color="var(--text-1)"
                cursor={"pointer"}
                size={25}
              />
            </span>
          </div>
        </div>
        <div className="az-content-body pd-r-20 pd-l-20 pd-t-5 mx-auto animated fadeInDown">
          <div className="text-center">
            <h1>Configurações da conta</h1>
            <p>
              Altere suas preferências e dados, deixe a plataforma do seu jeito!
            </p>
          </div>

          <div className="centered-flex">
            <label
              style={{ position: "relative" }}
              htmlFor={!isLoadingUpload ? "file-input" : ""}
            >
              <img
                style={{
                  width: 100,
                  height: 100,
                  border: "1px solid var(--border)",
                  display: "block",
                  cursor: isLoadingUpload ? "default" : "pointer",
                  filter: isLoadingUpload ? "brightness(0.1)" : "",
                  objectFit: "cover",
                }}
                alt=""
                className="az-img-user mx-auto hovered-profile-picture"
                src={getProfilePictureURI(newProfileImage)}
              />
              {isLoadingUpload ? (
                <span
                  style={{
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    top: 30,
                    left: 0,
                    marginRight: "0px",
                    textAlign: "center",
                    padding: "2%",
                    borderRadius: "12px",
                    cursor: isLoadingUpload ? "default" : "pointer",
                  }}
                >
                  <Spinner animation="border" color="#ffffff" />
                </span>
              ) : (
                <span
                  style={{
                    position: "absolute",
                    right: "0%",
                    bottom: "5%",
                    marginRight: "0px",
                    textAlign: "center",
                    background: "rgba(242, 242, 242, 1.0)",
                    padding: "2%",
                    borderRadius: "12px",
                    cursor: "pointer",
                  }}
                >
                  <MdEdit size={25} color="var(--dark)" />
                </span>
              )}

              <input
                onChange={(e) => handleFileChange(e)}
                id="file-input"
                className="d-none"
                type="file"
              />
            </label>
          </div>

          <form className="form mg-t-20" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label text-black">Nome do usuario</label>
              <input
                type="text"
                className="form-control"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                minLength={5}
                placeholder={"Insira seu novo nome"}
              />
            </div>

            <div className="mb-3">
              <label className="form-label text-black">
                Perfil de investidor
              </label>
              <button
                type="button"
                style={{
                  backgroundColor: "var(--bg-8)", color: "var(--text-1)",
                  borderRadius: 13,
                  border: "1px solid gray",
                }}
                onClick={() => handleInvestorTypesExpands()}
                className="btn btn-primary wd-100p"
              >
                {parseInvestorTypeSimple(getInvestorTypeToShow())}
                {expandedButtons.investorTypes ? (
                  <IoIosArrowUp size={15} />
                ) : (
                  <MdExpandMore size={20} />
                )}
              </button>
              {expandedButtons.investorTypes && (
                <div className="mg-t-15 pd-10 animated fadeInDown">
                  {investorProfiles.map((item, i) => {
                    return (
                      <div key={i} className="mb-3 cursor-pointer">
                        <span onClick={() => handleInvestorTypeClick(i)}>
                          <Form.Check type={"radio"}>
                            <Form.Check.Input
                              type={"radio"}
                              isValid
                              onChange={() => handleInvestorTypeClick(i)}
                              checked={
                                item.investorType === getInvestorTypeToShow()
                                  ? true
                                  : false
                              }
                            />
                            <Form.Check.Label className="tx-medium">
                              {item.title} {item.icon}
                            </Form.Check.Label>
                            <br />
                            <span>{item.description}</span>
                            <Form.Control.Feedback type="valid">
                              Normalmente indicado para {item.indicatedFor}
                            </Form.Control.Feedback>
                          </Form.Check>
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {!isExternalAuth && (
              <div className="mb-3">
                <label className="form-label text-black">
                  Nova senha (Opcional)
                </label>
                <input
                  type="password"
                  className="form-control"
                  value={newPasswordValue}
                  onChange={(e) => setNewPasswordValue(e.target.value)}
                  minLength={7}
                  placeholder="*******"
                />
              </div>
            )}
            {newPasswordValue.length > 6 && (
              <div className="mb-3">
                <label className="form-label text-black">
                  Confirme sua nova senha
                </label>
                <input
                  type="password"
                  className="form-control"
                  value={confirmNewPasswordValue}
                  onChange={(e) => setConfirmNewPasswordValue(e.target.value)}
                  minLength={7}
                  placeholder="*******"
                />
              </div>
            )}
            {newPasswordValue.length > 6 &&
              confirmNewPasswordValue.length > 6 && (
                <div className="mb-3">
                  <label className="form-label text-black">
                    Por motivos de segurança, insira sua senha antiga
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    value={oldPasswordValue}
                    onChange={(e) => setOldPasswordValue(e.target.value)}
                    minLength={7}
                    placeholder="*******"
                  />
                </div>
              )}

            <div className="d-grid my-4 d-flex flex-column align-items-center">
              {errorMsg !== "" && (
                <span
                  className="my-2"
                  style={{
                    color: "red",
                    textAlign: "center",
                  }}
                >
                  {errorMsg}
                </span>
              )}
              <button
                className="btn btn-primary"
                style={{
                  borderRadius: 10,
                  width: "50%",
                  backgroundColor: projectPrimaryColor,
                }}
                type="submit"
              >
                Salvar alterações
              </button>
            </div>
          </form>
          <div className="mg-t-20" />
        </div>
      </Modal>
    );
  } else if (userData === "error") {
    return fatalError();
  } else {
    return <div></div>;
  }
}

const defaultInvestorProfiles = [
  {
    title: "Agressivo",
    investorType: 0,
    description:
      "Realiza diversas operações visando curto prazo com duração de horas ou dias.",
    indicatedFor: "Day Traders",
    icon: <GiRunningNinja />,
    status: false,
  },
  {
    title: "Moderado",
    investorType: 1,
    description:
      "Realiza operações visando médio prazo com duração de semanas ou meses.",
    indicatedFor: "Swing Traders",
    icon: <GiWalk />,
    status: false,
  },
  {
    title: "Conservador",
    investorType: 2,
    description:
      "Realiza operações visando longo prazo com duração de meses ou anos.",
    indicatedFor: "Buy and Holders",
    icon: <GiCoffeeCup />,
    status: false,
  },
];


/**
 * The all done page, when everything went well.
 * @returns {JSX.Element}
 */
const allDonePage = () => {
  return (
    <Modal show={true} fullscreen={true} size="md">
      <div className="pd-50">
        <div className="text-center">
          <MdDone size={40} />
          <h2>Tudo certo</h2>
          <p>Suas configurações foram salvas com sucesso!</p>

          <Link to="/dashboard">
            <span>Clique aqui para voltar para o menu principal.</span>
          </Link>
        </div>
      </div>
    </Modal>
  );
};

const loadingSkeleton = () => {
  return (
    <Modal show={true} fullscreen={true} size="md">
      <div className="pd-50">
        <div className="text-center mg-b-20">
          <Skeleton height={100} width={100} borderRadius={50} />
        </div>
        <div className="mx-auto">
          <Skeleton count={7} />
        </div>
      </div>
    </Modal>
  );
};

const fatalError = () => {
  return (
    <Modal show={true} fullscreen={true} size="md">
      <div className="az-content-body pd-50">
        <div className="text-center">
          <span>
            <GiRocket size={48} />
          </span>
          <h4>Houston, temos um problema!</h4>
          <span>
            Infelizmente, alguns dados não aterrissaram da maneira correta.
            <br />
            <span
              onClick={() => {
                return window.location.reload();
              }}
              className="cursor-pointer tx-primary"
            >
              Clique aqui para tentar novamente.
            </span>
          </span>
        </div>
      </div>
    </Modal>
  );
};
